import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) { // always route to pagetop
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/attestations',
      component: () => import('./views/AttestationsView.vue'),
      children: [
        {
          path: 'all',
          name: 'attestations-list',
          component: () => import('./views/Attestations/AttestationList.vue'),
        },
        {
          path: 'one',
          name: 'attestations-detail',
          props: true,
          component: () => import('./views/Attestations/AttestationDetail.vue'),
        },
        {
          path: 'hist',
          name: 'attestation-history-detail',
          props: true,
          component: () => import('./views/Attestations/AttestationHistoricalDetail.vue'),
        },
      ]
    },
    {
      path: '/sso',
      name: 'sso',
      component: () => import('./views/Login/AuthSso.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/sso/error',
      name: 'sso-error',
      component: () => import('./views/Login/AuthSsoError.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/sso/logout',
      name: 'sso-logout',
      component: () => import('./views/Login/AuthSsoLogout.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/reporting',
      name: 'reporting-page',
      component: () => import('./views/Reporting/Reporting.vue')
    },
    {
      path: '/reporting/:reportingCategory',
      props: true,
      name: 'reporting-cat-page',
      component: () => import('./views/Reporting/ReportingCatPage.vue')
    },
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('./views/Login/AcceptTerms.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/open-enrollment',
      name: 'open-enrollment',
      component: () => import('./views/OpenEnrollment/OpenEnrollment.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/open-enrollment/create-event',
      name: 'open-enrollment-create-event',
      component: () => import('./views/OpenEnrollmentCreateEvent/OpenEnrollmentCreateEvent.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/open-enrollment/event-summary',
      name: 'open-enrollment-event-summary',
      component: () => import('./views/OpenEnrollmentEventSummary/OpenEnrollmentEventSummary.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/client-onboarding',
      name: 'client-onboarding',
      component: () => import('./views/ClientOnBoarding.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/client-onboarding-complete',
      name: 'client-onboarding-complete',
      beforeEnter(to, from, next) {
        if (window.top.location.href !== window.self.location.href) {
          window.top.location.href = '/#/client-onboarding-complete-result?userMessage=' + to.query.userMessage
        }
      }
    },
    {
      path: '/client-onboarding-complete-result',
      name: 'client-onboarding-complete-result',
      component: () => import('./views/ClientOnboarding/Complete.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/ClientOnboarding/Faq.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/two-factor-auth',
      name: 'two-factor-auth',
      component: () => import('./views/Login/TwoFactorAuth.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('./views/Login/ForgotPassword.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/forgot-userid',
      name: 'forgot-userid',
      component: () => import('./views/Login/ForgotUserId.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/resend-signup-email',
      name: 'resend-signup-email',
      component: () => import('./views/Login/ResendSignupEmail.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/auth-choice',
      name: 'auth-choice',
      component: () => import('./views/Login/AuthChoice.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/update-password',
      name: 'update-password',
      component: () => import('./views/Login/UpdatePassword.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('./views/Login/ResetPassword.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true,
        emailRoute: true
      }
    },
    {
      path: '/complete-registration',
      name: 'complete-registration',
      component: () => import('./views/Login/CompleteRegistration.vue'),
      meta: {
        isPublic: true,
        skipSessionHealthCheck: true,
        emailRoute: true
      }
    },
    {
      path: '/dashboard-prompt',
      name: 'dashboard-prompt',
      component: () => import('./views/Login/DashboardPrompt.vue'),
      meta: {
        skipSessionHealthCheck: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import('./views/Contacts/Contacts.vue')
    },
    {
      path: '/resources',
      name: 'resources',
      component: () => import('./views/Resources/Resources.vue')
    },
    {
      path: '/provider-locator',
      name: 'locator',
      component: () => import('./views/Locator/ProviderLocator.vue')
    },
    {
      path: '/client-onboarding-management',
      component: () => import('./views/ClientOnboardingManagement.vue'),
      children: [

        {
          name: 'client-onboarding-management',
          path: '',
          component: () => import('./views/ClientOnboardingManagement/Home.vue')
        },
        {
          path: ':applicationId/recipients',
          name: 'recipients',
          component: () => import('./views/ClientOnboardingManagement/Recipients.vue')
        },
        {
          path: '/add-recipient',
          name: 'add-recipient',
          component: () => import('./views/ClientOnboardingManagement/AddRecipient.vue')
        }

      ]
    },
    {
      path: '/members',
      component: () => import('./views/MemberManagement.vue'),
      children: [
        {
          name: 'member-management',
          path: '',
          component: () => import('./views/MemberManagement/Home.vue')
        },
        {
          path: 'coverage',
          component: () => import('./views/MemberManagement/Coverage.vue'),
          children: [
            {
              path: 'view',
              name: 'coverage-view',
              component: () => import('./views/MemberManagement/Coverage/View.vue'),
            },
            {
              path: 'add',
              name: 'coverage-add',
              component: () => import('./views/MemberManagement/Coverage/Add.vue'),
            },
            {
              path: 'edit',
              name: 'coverage-edit',
              component: () => import('./views/MemberManagement/Coverage/Edit.vue'),
            }

          ]
        },
        {
          path: 'add-new-family',
          component: () => import('./views/MemberManagement/AddNewFamily.vue'),
          children: [
            {
              name: 'add-new-family',
              path: '',
              component: () =>
                import('./views/MemberManagement/AddNewFamily/Home.vue')
            },
            {
              name: 'member-found',
              path: 'member-found',
              component: () =>
                import('./views/MemberManagement/AddNewFamily/MemberFound.vue')
            },
            {
              name: 'primary-subscriber-details',
              path: 'primary-subscriber-details',
              component: () =>
                import('./views/MemberManagement/AddNewFamily/PrimarySubscriberDetails.vue')
            },
            {
              name: 'add-dependent',
              path: 'add-dependent',
              component: () =>
                import('./views/MemberManagement/AddNewFamily/AddDependent.vue'),
            },
            {
              name: 'confirmation',
              path: 'confirmation',
              component: () =>
                import('./views/MemberManagement/AddNewFamily/Confirmation.vue'),
            }
          ]
        },
        {
          path: 'transactions',
          name: 'member-transactions',
          component: () => import('./views/MemberManagement/MemberTransactions.vue')
        },
        {
          path: 'enrollment-report',
          name: 'enrollment-report',
          component: () => import('./views/MemberManagement/EnrollmentReport.vue')
        },
        {
          path: 'edit',
          name: 'member-edit',
          component: () => import('./views/MemberManagement/MemberEdit.vue'),
        },
        {
          path: 'dependents/edit',
          name: 'dependent-edit',
          component: () => import('./views/MemberManagement/MemberEdit.vue'),
        },
        {
          path: 'details',
          name: 'member-details',
          component: () => import('./views/MemberManagement/MemberDetails.vue'),
        }
      ]
    },
    {
      path: '/billing',
      name: 'billing',
      component: () => import('./views/Billing.vue'),
      children: [
        {
          path: 'overview',
          name: 'billing-overview',
          component: () => import('./views/Billing/BillingOverview.vue')
        },
        {
          path: 'pay',
          name: 'make-payment',
          meta: {
            paymentsRequired: true
          },
          component: () => import('./views/Billing/MakePayment.vue')
        },
        {
          path: 'pay/confirmation',
          name: 'payment-confirmation',
          meta: {
            paymentsRequired: true
          },
          component: () => import('./views/Billing/PaymentConfirmation.vue')
        },
        {
          path: 'history',
          name: 'billing-payment-history',
          component: () => import('./views/Billing/PaymentHistory.vue')
        },
        {
          path: 'payment-methods',
          name: 'billing-manage-payment-methods',
          meta: {
            paymentsRequired: true
          },
          component: () => import('./views/Billing/ManagePaymentMethods.vue')
        },
        {
          path: 'auto-payment-methods',
          name: 'billing-manage-auto-payment-methods',
          meta: {
            paymentsRequired: true
          },
          component: () => import('./views/Billing/ManageAutoPaymentMethods.vue')
        },
        {
          path: 'invoices',
          name: 'invoice-details',
          component: () => import('./views/Billing/InvoiceDetails.vue'),
        }
      ]
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/Search.vue'),
      children: [
        {
          path: 'member',
          name: 'search-member',
          component: () => import('./views/Search/MemberSearch.vue'),
        },
        {
          path: 'user',
          name: 'search-user',
          component: () => import('./views/Search/UserSearch.vue')
        },
        {
          path: 'invoice',
          name: 'search-invoice',
          component: () => import('./views/Search/InvoiceSearch.vue')
        },
        {
          path: 'group',
          name: 'search-group',
          component: () => import('./views/Search/GroupSearch.vue')
        }
      ]
    },
    {
      path: '/administrator-management',
      component: () => import('./views/UserManagement.vue'),
      children: [
        {
          name: 'user-management',
          path: '',
          component: () => import('./views/UserManagement/Home.vue')
        },
        {
          path: 'add',
          name: 'user-add',
          component: () => import('./views/UserManagement/UserAdd.vue'),
        },
        {
          path: 'add-users-to-group',
          name: 'add-users-to-group',
          component: () => import('./views/UserManagement/AddUsersToGroup.vue')
        },
        {
          path: 'update-your-password',
          name: 'update-your-password',
          component: () => import('./views/UserManagement/UpdateYourPassword.vue')
        },
        {
          path: 'view',
          name: 'user-view',
          component: () => import('./views/UserManagement/UserView.vue'),
        },
        {
          path: 'profile',
          name: 'user-profile',
          component: () => import('./views/UserManagement/MyProfileUserView.vue'),
        },
        {
          path: 'edit',
          name: 'user-edit',
          component: () => import('./views/UserManagement/UserEdit.vue'),
        },
        {
          path: 'password',
          name: 'update-user-password',
          component: () => import('./views/UserManagement/UpdateUserPassword.vue'),
        },
        {
          path: 'add-sub-group',
          name: 'user-add-sub-group',
          component: () => import('./views/UserManagement/v2/UserAddSubGroup.vue'),
        }

      ]
    },
    {
      path: '/groups',
      component: () => import('./views/Groups.vue'),
      children: [
        {
          name: 'group',
          path: 'groups',
          component: () => import('./views/Groups/Group.vue'),
        },
        {
          name: 'group-benefits',
          path: 'group-benefits',
          component: () => import('./views/Groups/GroupBenefitsTiers.vue'),
          props: true
        },
        {
          name: 'subgroup',
          path: 'subgroups',
          component: () => import('./views/Groups/SubGroup.vue'),
        }
      ]
    },
    {
      name: 'content-page',
      path: '/page/:contentPageName',
      component: () => import('./views/ContentPage.vue')
    },
    {
      path: '/contactus',
      name: 'contact-us',
      component: () => import('./views/ContactUs/ContactUs.vue')
    }
  ]
});
